<template>
  <button type="button" class="back-to-site" :aria-label="$t('auth.backToSite')">
    <span class="material-icons" aria-hidden="true">arrow_back</span>
    <img src="@/assets/logo.png" alt="" class="back-to-site-logo">
    <span>GoodScriber</span>
  </button>
</template>

<script>
// 整页盖在站点之上的页面（登录、购买）左上角的返回入口
export default {
  name: 'BackToSiteButton'
}
</script>

<style scoped>
.back-to-site {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 40px;
  margin-left: calc(var(--space-2) * -1);
  padding: 0 var(--space-3) 0 var(--space-2);
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--ink-primary);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.back-to-site:hover {
  background: var(--surface-subtle);
}

.back-to-site:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring-brand-strong);
}

.back-to-site .material-icons {
  color: var(--ink-tertiary);
  font-size: 20px;
}

.back-to-site-logo {
  width: 28px;
  height: 28px;
  clip-path: circle(50% at center);
}
</style>
